import classNames from 'classnames';
import React, { useMemo } from 'react';

export const Label = (props) => {
    const { children, tagName = 'label', className, actionModal, htmlFor, ...restProps } = props;
    const labelTemplate = useMemo(() => {
        if(tagName === 'label') {
            return <label htmlFor={htmlFor} {...restProps}>{children}</label>
        }
        return <p {...restProps}>{children}</p>
    }, [tagName, children, restProps])

    return (
        <div className={classNames('field-label', className)}>
            { labelTemplate }

            { actionModal &&
                <span className="action-modal-wrapper">
                    <button
                        onClick={actionModal.onClick}
                        className='action-modal'
                        type='button'
                        data-toggle='modal'
                    >
                        <i className='maificon maificon-information-cercle' aria-hidden='true' />
                    </button>
                </span>
            }
        </div>
    )
}